import { Component, Input } from "@angular/core";
import { IContributionsQuoteDTO } from "../models/IContributionsQuote";

@Component({
  selector: "app-calculator",
  templateUrl: "./calculator.component.html",
  styleUrls: ["./calculator.component.scss"],
})
export class CalculatorComponent {
  public searchResults?: IContributionsQuoteDTO;
  public error?: string;

  public onResultChanged(result: IContributionsQuoteDTO) {
    this.searchResults = result;
  }

  public onCalculError(error: string) {
    this.error = error;
  }

  public displayResult(): boolean {
    const displayResult = this.searchResults || this.error;
    return !!displayResult;
  }
}
